export default function isUndefindedOrNull(content ?: any){
    if(!content || content === null){
       return true;
    }
    return false;
}
